import { APIData } from "types/cms/frontendTypes"
import { CMS_DEFAULT_LOCALE } from "store/dataReducers/cmsPilotSlice"
import { SurveyTemplateLocalization } from "types/apis/surveyInterfaces"

/**
 * Get localized template question title (override) for a specific locale
 * Returns undefined if no override exists for the locale
 */
export const getLocalizedTemplateQuestionTitle = (
  templateToUse: APIData<'api::survey-template.survey-template'>,
  templateQuestion: typeof templateToUse.templateQuestions[0],
  locale: string
): string | undefined => {
  if (locale === CMS_DEFAULT_LOCALE) {
    return templateQuestion.title
  }
  const localizations: SurveyTemplateLocalization[] = (templateToUse as any).localizations || []
  const localeData = localizations.find((l: SurveyTemplateLocalization) => l.locale === locale)
  if (localeData) {
    const localizedTemplateQuestion = localeData.templateQuestions.find(
      (tq) => tq.questionUid === templateQuestion.questionUid
    )
    return localizedTemplateQuestion?.title
  }
  return undefined
}

/**
 * Get localized question title for a specific locale
 * Falls back to default locale title if localization not found
 */
export const getLocalizedQuestionTitle = (
  question: APIData<'api::survey-question.survey-question'>,
  locale: string
): string => {
  if (locale === CMS_DEFAULT_LOCALE) {
    return question.title
  }
  const questionLocalizations: any[] = (question as any).localizations || []
  const questionLocaleData = questionLocalizations.find((l: any) => l.locale === locale)
  return questionLocaleData?.title
}

/**
 * Get display title (template override or question title) for a specific locale
 * Returns template override if present, otherwise returns question title
 */
export const getDisplayTitle = (
  templateToUse: APIData<'api::survey-template.survey-template'>,
  templateQuestion: typeof templateToUse.templateQuestions[0],
  question: APIData<'api::survey-question.survey-question'> | null,
  locale: string
): string => {
  if (!question) return ''
  const templateTitle = getLocalizedTemplateQuestionTitle(templateToUse, templateQuestion, locale)
  const questionTitle = getLocalizedQuestionTitle(question, locale)
  return templateTitle || questionTitle || ''
}
